import React from 'react';
import { Slide1Cover, Slide3Founders, Slide4WhatsBuilt, Slide5DesignArsenal } from './components/Slides1To5';
import { SlideWhoWeAre, SlideCrossBorder, SlideFocus, SlideWhatWeDo, SlideHowWeWork, SlideCTA } from './components/ClientSlides';
export function App() {
  return <main className="bg-white min-h-screen w-full selection:bg-black selection:text-white" data-id="element-0">
      <Slide1Cover data-id="element-1" />
      <SlideWhoWeAre data-id="element-2" />
      <SlideCrossBorder data-id="element-3" />
      <Slide3Founders data-id="element-4" />
      <SlideWhatWeDo data-id="element-5" />
      <Slide4WhatsBuilt data-id="element-6" />
      <Slide5DesignArsenal data-id="element-7" />
      <SlideFocus data-id="element-8" />
      <SlideHowWeWork data-id="element-9" />
      <SlideCTA data-id="element-10" />
    </main>;
}